// LIBRARIES
import styled from "styled-components";
import { CircularProgress } from "@mui/material";

// MISC
import { COLORS } from "constants/styleVariables";

export const AuditContainer = styled.div`
width: 100%;
min-width: 1400px;
height: 100%;
display: flex;
flex-direction: column;
background-color: #F5F5F5;
border-radius: 24px;
padding: 32px;
`;

export const LodingSign = styled(CircularProgress)`
  && {
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    color: ${COLORS.rainbowIndigo};
    opacity: 1 !important;
  }
`;
